export default __webpack_public_path__ + "static/ai-coding-competences-tools-training-271db326b4470f385939dbdc8c571eb3.jpg";